import { Injectable } from '@angular/core';

import { toFixed } from '../../../../core/services/utils/numbers';
import { isVenda } from '../../../configuracoes/app/pedido/tipo-venda';

@Injectable({
    providedIn: 'root'
})
export class PedidoItemValidateService {

    /** Valida se a soma do percentual de desconto 1 e 2 é maior que o percentual máximo permitido de desconto para o item do pedido */
    isPercDescontoMaximoExcedido(percDesconto1: number, percDesconto2: number, percDescontoMaximo: number): boolean {
        // Se não possuir percentual de desconto máximo então não está excedido
        if (percDescontoMaximo == null || percDescontoMaximo === undefined) {
            return false;
        }

        percDesconto1 = percDesconto1 && !isNaN(percDesconto1) ? Number(percDesconto1) : 0;
        percDesconto2 = percDesconto2 && !isNaN(percDesconto2) ? Number(percDesconto2) : 0;
        percDescontoMaximo = percDescontoMaximo && !isNaN(percDescontoMaximo) ? Number(percDescontoMaximo) : 0;

        // Somando o percentual de desconto 1 e 2 para obter o desconto total do item
        const percDescontoTotal = toFixed(percDesconto1 + percDesconto2, 2);

        // Se o percentual de desconto total do item for maior que o percentual máximo permitido então está excedido
        return percDescontoTotal > percDescontoMaximo;
    }

    /** Valida se o valor unitário é maior ou igual ao valor mínimo permitido */
    validarValorUnitarioMinimo(valorUnitarioMinimo: number, valorUnitario: number): boolean {
        if (valorUnitarioMinimo == null || valorUnitarioMinimo === undefined) {
            return true;
        }
        if (valorUnitario == null || valorUnitario === undefined) {
            return true;
        }
        valorUnitarioMinimo = valorUnitarioMinimo && !isNaN(valorUnitarioMinimo) ? Number(valorUnitarioMinimo) : 0;
        valorUnitario = valorUnitario && !isNaN(valorUnitario) ? Number(valorUnitario) : 0;


        return valorUnitario >= valorUnitarioMinimo;
    }

    /** Valida se o valor unitário é menor ou igual ao valor máximo permitido */
    validarValorUnitarioMaximo(valorUnitarioMaximo: number, valorUnitario: number): boolean {
        if (valorUnitarioMaximo == null || valorUnitarioMaximo === undefined) {
            return true;
        }
        if (valorUnitario == null || valorUnitario === undefined) {
            return true;
        }
        valorUnitarioMaximo = valorUnitarioMaximo && !isNaN(valorUnitarioMaximo) ? Number(valorUnitarioMaximo) : 0;
        valorUnitario = valorUnitario && !isNaN(valorUnitario) ? Number(valorUnitario) : 0;


        return valorUnitario <= valorUnitarioMaximo;
    }

    /** Valida se a quantidade da caixa de embarque está fracionada e for para bloquear quantidade fracionada no pedido */
    validarQuantidadeFracionada(pedidoTipoVenda: number, caixaEmbarqueFracionada: boolean, bloquearQuantidadeFracionadaPedido: boolean): boolean {
        // Se não for um pedido de venda então não aplica a regra e retorna que está ok
        if (!isVenda(pedidoTipoVenda)) {
            return true;
        }
    	// Se a caixa de embarque não estiver fracionada então está ok
    	if (!caixaEmbarqueFracionada) {
    		return true
    	}
    	// Se não bloquear a quantidade fracionada no pedido então está ok
    	if (!bloquearQuantidadeFracionadaPedido) {
    		return true
    	}

    	// Bloqueia quando a caixa de embarque estiver fracionada e for para bloquear
    	return false
    }
}
